import React from "react"
import { createSetStateAction } from "../../context/api"
import { DrawerData, DrawerState } from "./state"

type SDT = React.Dispatch<React.SetStateAction<DrawerState>>

export interface IDrawerApi {
  setState: (value: Partial<DrawerState>) => void;
  setOpen: (value: boolean) => void;
  setData: (data: DrawerData) => void;
}

export const initApi = (setState_: SDT): IDrawerApi => {
  const setState = createSetStateAction(setState_)

  const setOpen = (value: boolean): void => {
    setState_((state) => ({
      ...state,
      isOpen: value,
    }))
  }

  const setData = (data: DrawerData): void => {
    setState_((state) => ({
      ...state,
      data: {
        ...state.data,
        ...data
      },
    }))
  }

  return {
    setState,
    setOpen,
    setData,
  }
}

